




























































import {
    computed,
    defineComponent,
    PropType,
} from '@vue/composition-api';
import {
    SdsBadge,
    SdsIcon,
} from '@superbet-group/web.lib.ui-components';

type BadgeType = {
    background: string;
    variant: string;
    styling: string;
    size: string;
    shape: string;
};

export default defineComponent({
    name: 'MenuItem',
    props: {
        index: {
            type: Number,
            required: false,
            default: 0,
        },
        length: {
            type: Number,
            required: false,
            default: 1,
        },
        type: {
            type: String as PropType<'item' | 'info' | 'link' | 'toggle' | 'radio'>,
            required: true,
            default: 'item',
        },
        isPage: {
            type: Boolean,
            required: false,
            default: false,
        },
        action: {
            type: Function as PropType<() => void>,
            required: false,
            default: () => {},
        },
        icon: {
            type: String,
            required: false,
            default: '',
        },
        label: {
            type: String,
            required: true,
        },
        subtext: {
            type: String,
            required: false,
            default: '',
        },
        description: {
            type: String,
            required: false,
            default: '',
        },
        tag: {
            type: String,
            required: false,
            default: '',
        },
        subtextTitle: {
            type: String,
            required: false,
            default: '',
        },
        subtextColor: {
            type: String as PropType<'info' | 'warning' | 'danger' | 'success'>,
            required: false,
            default: 'default',
        },
        isSelected: {
            type: Boolean,
            required: false,
            default: false,
        },
        isDisabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        badge: {
            type: Object as PropType<BadgeType>,
            required: false,
            default: null,
        },
    },
    setup(props) {
        function getAppearance() {
            if (props.length === 1) {
                return 'individual';
            }

            switch (props.index) {
                case 0:
                    return 'start';
                case props.length - 1:
                    return 'end';
                default:
                    return 'standard';
            }
        }

        return {
            apperance: computed(getAppearance),
        };
    },
    components: {
        SdsBadge,
        SdsIcon,
    },
});
